import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FAQSection } from './FAQSection';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * HomepageFAQSection - Featured FAQs for homepage with styled cards
 */
export const HomepageFAQSection = ({ 
  limit = 8,
  title = "Frequently Asked Questions",
  subtitle = "Get answers to common questions about LLC formation, compliance, and more.",
  showViewAll = true,
  variant = 'light'
}) => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFAQs = async () => {
      try {
        const response = await axios.get(`${API}/public/faq-items`, {
          params: { limit }
        });
        setFaqs(response.data.items || []);
      } catch (error) {
        console.error('Error fetching FAQs:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFAQs();
  }, [limit]);

  return (
    <FAQSection
      title={title}
      subtitle={subtitle}
      items={faqs}
      loading={loading}
      showViewAll={showViewAll}
      viewAllLink="/faq"
      viewAllText="View all 65+ FAQs"
      maxItems={limit}
      variant={variant}
      data-testid="homepage-faq-section"
    />
  );
};

export default HomepageFAQSection;
